import { createTrackingPageProvider } from '@edreamsodigeo/frontend-core';
const FLIGHT_INFO_PAGE = '/flights/flightsummary/';
const FLIGHT_INFO_PAGE_CATEGORY = 'flights_summary';
const TripSummaryTrackingProvider = createTrackingPageProvider({
  category: FLIGHT_INFO_PAGE_CATEGORY,
  pageMapper: () => FLIGHT_INFO_PAGE
});
export default TripSummaryTrackingProvider;